import { usePeopleByEmail } from '@renderer/chat/hooks/usePeople'
import type { QuickTourTarget } from '../quicktour/build-tour-steps'
import { SidepanelUpcomingList } from './sections/upcoming-list'
import { SidepanelTodosSection } from './sections/todos'
import { TODO_GROUP_PAGE_SIZE } from './sections/todos-order'

/**
 * Home in the To-dos layout: Upcoming, then each group of to-dos under plain
 * headings. No dividers or section headers, and nothing to reorder or collapse.
 * New reminders are written in the blank to-do atop To-dos.
 */
export function TodosHome({
  getQuickTourSectionClass,
}: {
  getQuickTourSectionClass: (section: QuickTourTarget) => string
}) {
  // Meetings without a brief say who they're with.
  const peopleByEmail = usePeopleByEmail()

  return (
    // A section to the panel's hotkeys, so the arrow keys, Tab and Ctrl+N/P step through its rows.
    <div data-section="todos" className="flex flex-col px-2 pb-4">
      <div data-tour-section="upcoming" className={getQuickTourSectionClass('upcoming')}>
        <SidepanelUpcomingList
          heading="Upcoming Events"
          paging={{ first: 2, more: TODO_GROUP_PAGE_SIZE }}
          rowAppearance="todo"
          peopleByEmail={peopleByEmail}
        />
      </div>
      <SidepanelTodosSection />
    </div>
  )
}
